import { gql } from "@apollo/client";

export const GET_VISITA_CP = gql`
  query visitaCP($idVisita: Int!, $idEvaluacion: Int!) {
    visitaCP(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
      idVisita

      enfermedadOncologica
      soporteNutricional
      medicoCabecera
      idComboRIValorECOG
      examenFisico
      sondaVesical
      cateter
      sondaNasogastrica
      idESAS
      idComboRIValorLANSKY
      idComboRIValorEscalaDolor

      fLACCR
      resultadoFLACCR
      gustaveRoussy
      resultadoGustaveRoussy
      pedFPSR
      resultadoFPSR
      escalaNumericaDolor
      resultadoEscalaNumericaDolor

      nauseas
      dolor
      disnea
      ansiedad
      depresion
      anorexia
      bienestar
      cansancio
      insomnio
      somnolencia
      constipacion
      eSAS
      resultadoESAS

      cuidadorPrincipal
      espacioCuidado
      comunicacionDecisiones

      observacionSituacionActual
      observacionRequerimientosActuales

      listaDiagnostico {
        idItemDiagnostico
        idDiagnostico
        descripcionItemDiagnostico
        descripcionDiagnostico
      }
      alergias{
        idAlergia
        descripcionAlergia
        descripcionAlergiaOtro
      }
      medicacionDosificacion
      adicionalesVisita{
        idVisita
        idComboRIValorReqAdicional
      }
      opioidesVisita{
        idOpioide
        idComboOpioide
        dosis
      }
    }
  }
`;

export const adaptVisitaCP = (data) => ({
  idVisita: data?.idVisita,

  enfermedadOncologica: !!data?.enfermedadOncologica,
  soporteNutricional: !!data?.soporteNutricional,

  medicoCabecera: data?.medicoCabecera || "",
  idComboRIValorECOG: data?.idComboRIValorECOG ?? null,
  examenFisico: data?.examenFisico || "",

  sondaVesical: !!data?.sondaVesical,
  cateter: !!data?.cateter,
  sondaNasogastrica: !!data?.sondaNasogastrica,

  eSAS: data?.eSAS ?? false,
  idESAS: data?.idESAS ?? null,
  idComboRIValorLANSKY: data?.idComboRIValorLANSKY ?? null,
  idComboRIValorEscalaDolor: data?.idComboRIValorEscalaDolor ?? null,

  fLACCR: !!data?.fLACCR,
  resultadoFLACCR: data?.resultadoFLACCR ?? null,
  gustaveRoussy: !!data?.gustaveRoussy,
  resultadoGustaveRoussy: data?.resultadoGustaveRoussy ?? null,

  pedFPSR: !!data?.pedFPSR,
  resultadoFPSR: data?.resultadoFPSR ?? null,
  escalaNumericaDolor: !!data?.escalaNumericaDolor,
  resultadoEscalaNumericaDolor: data?.resultadoEscalaNumericaDolor ?? null,

  nauseas: data?.nauseas ?? null,
  dolor: data?.dolor ?? null,
  disnea: data?.disnea ?? null,
  ansiedad: data?.ansiedad ?? null,
  depresion: data?.depresion ?? null,
  anorexia: data?.anorexia ?? null,
  bienestar: data?.bienestar ?? null,
  cansancio: data?.cansancio ?? null,
  insomnio: data?.insomnio ?? null,
  somnolencia: data?.somnolencia ?? null,
  constipacion: data?.constipacion ?? null,
  resultadoESAS: !!data?.eSAS && !!data?.resultadoESAS ? data?.resultadoESAS : null,

  cuidadorPrincipal: data?.cuidadorPrincipal || "",
  espacioCuidado: data?.espacioCuidado || "",
  comunicacionDecisiones: data?.comunicacionDecisiones || "",

  observacionSituacionActual: data?.observacionSituacionActual || "",
  observacionRequerimientosActuales: data?.observacionRequerimientosActuales || "",

  listaDiagnostico: data?.listaDiagnostico?.map((x) => {
    return {
      codigoItem: x.idItemDiagnostico,
      codigo: x.idDiagnostico,
      descripcionItem: x.descripcionItemDiagnostico,
      descripcion: x.descripcionDiagnostico
    };
  }) || [],
  alergiasDatosClinicos: data?.alergias?.map((a) => a.idAlergia) || [],
  descripcionAlergiaOtro: data?.alergias?.find((a) => a.descripcionAlergia?.toLowerCase() === 'otros')?.descripcionAlergiaOtro || '',
  tratamientos: data?.medicacionDosificacion || [],
  idComboRIValorReqAdicional: data?.adicionalesVisita?.map((av) => av.idComboRIValorReqAdicional) || [],
  opioides: data?.opioidesVisita?.map((op) => ({
    idOpioide: op.idOpioide,
    idComboOpioide: op.idComboOpioide,
    dosis: op.dosis
  })) || []
});